export type TimeScale = "daily" | "weekly" | "monthly" | "quarterly" | "yearly";
export const TimeScaleEnum = {
  Daily: "daily",
  Weekly: "weekly",
  Monthly: "monthly",
  Quarterly: "quarterly",
  Yearly: "yearly"
} as const;
